import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inheritsLoose from "@babel/runtime/helpers/esm/inheritsLoose";
import React from 'react';
import { Sticky } from "../../Sticky";
import { CrossIcon } from "../../../internal/icons/CrossIcon";
import { isFunction } from "../../../lib/utils";
import { ThemeContext } from "../../../lib/theming/ThemeContext";
import { CommonWrapper } from "../../../internal/CommonWrapper";
import { cx } from "../../../lib/theming/Emotion";
import { styles } from "../SidePage.styles";
import { SidePageContext } from "../SidePageContext";
/**
 * Шапка сайдпейджа
 *
 * @visibleName SidePage.Header
 */

export var SidePageHeader = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(SidePageHeader, _React$Component);

  function SidePageHeader() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
    _this.context = _this.context;
    _this.state = {
      isReadyToFix: false
    };
    _this.theme = void 0;
    _this.wrapper = null;
    _this.lastRegularHeight = 0;

    _this.componentDidMount = function () {
      window.addEventListener('scroll', _this.update, true);
      _this.context.setHasHeader == null ? void 0 : _this.context.setHasHeader();
    };

    _this.componentWillUnmount = function () {
      window.removeEventListener('scroll', _this.update, true);
      _this.context.setHasHeader == null ? void 0 : _this.context.setHasHeader(false);
    };

    _this.update = function () {
      _this.updateReadyToFix();
    };

    _this.renderHeader = function (fixed) {
      var _cx, _cx2;

      if (fixed === void 0) {
        fixed = false;
      }

      return /*#__PURE__*/React.createElement("div", {
        className: cx(styles.header(_this.theme), (_cx = {}, _cx[styles.headerFixed(_this.theme)] = fixed, _cx))
      }, _this.renderClose(), /*#__PURE__*/React.createElement("div", {
        className: cx(styles.title(_this.theme), (_cx2 = {}, _cx2[styles.titleFixed()] = fixed, _cx2))
      }, isFunction(_this.props.children) ? _this.props.children(fixed) : _this.props.children));
    };

    _this.renderCloseContent = function (fixed) {
      return /*#__PURE__*/React.createElement(SidePageContext.Consumer, null, function (_ref) {
        var _cx3, _cx4;

        var requestClose = _ref.requestClose;
        return /*#__PURE__*/React.createElement("a", {
          className: cx(styles.close(_this.theme), (_cx3 = {}, _cx3[styles.fixed(_this.theme)] = fixed, _cx3)),
          onClick: requestClose,
          "data-tid": "SidePage__close"
        }, /*#__PURE__*/React.createElement("span", {
          className: cx(styles.closeIcon(_this.theme), (_cx4 = {}, _cx4[styles.fixed(_this.theme)] = fixed, _cx4))
        }, /*#__PURE__*/React.createElement(CrossIcon, null)));
      });
    };

    _this.renderClose = function () {
      var stickyOffset = parseInt(_this.theme.sidePageHeaderStickyOffset);
      return /*#__PURE__*/React.createElement(Sticky, {
        side: "top",
        offset: stickyOffset
      }, _this.renderCloseContent);
    };

    _this.updateReadyToFix = function () {
      if (_this.wrapper) {
        var wrapperScrolledUp = _this.wrapper.getBoundingClientRect().top;

        var isReadyToFix = _this.regularHeight + wrapperScrolledUp <= _this.fixedHeaderHeight;

        _this.setState(function (state) {
          return state.isReadyToFix !== isReadyToFix ? {
            isReadyToFix: isReadyToFix
          } : state;
        });
      }
    };

    _this.wrapperRef = function (el) {
      _this.wrapper = el;
    };

    return _this;
  }

  var _proto = SidePageHeader.prototype;

  _proto.render = function render() {
    var _this2 = this;

    return /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, function (theme) {
      _this2.theme = theme;
      return _this2.renderMain();
    });
  };

  _proto.renderMain = function renderMain() {
    var isReadyToFix = this.state.isReadyToFix;
    return /*#__PURE__*/React.createElement(CommonWrapper, this.props, /*#__PURE__*/React.createElement("div", {
      ref: this.wrapperRef
    }, isReadyToFix ? /*#__PURE__*/React.createElement(Sticky, {
      side: "top"
    }, this.renderHeader) : this.renderHeader()));
  };

  _createClass(SidePageHeader, [{
    key: "regularHeight",
    get: function get() {
      var isReadyToFix = this.state.isReadyToFix;

      if (!this.wrapper) {
        return 0;
      }

      if (!isReadyToFix) {
        this.lastRegularHeight = this.wrapper.getBoundingClientRect().height;
      }

      return this.lastRegularHeight;
    }
  }, {
    key: "fixedHeaderHeight",
    get: function get() {
      var theme = this.theme;
      return parseInt(theme.sidePageHeaderFixedLineHeight) + parseInt(theme.sidePageHeaderFixedPaddingY) * 2;
    }
  }]);

  return SidePageHeader;
}(React.Component);
SidePageHeader.__KONTUR_REACT_UI__ = 'SidePageHeader';
SidePageHeader.contextType = SidePageContext;